export interface IStudio {
  name: string;
  est: number;
  country: string;
  employee_count?: number;
  employee_info?: string;
  games?: string[];
  game_engine?: string[];
  sub_studio?: {
    name: string;
    est: number;
    country: string;
    /** 标签位置偏移 [offsetX, offsetY]，相对于蓝点(badge)的固定像素偏移 */
    labelPosition?: [number, number];
    employee_count?: number;
    employee_info?: string;
  };
  ratings: number;
  studio_info?: string;
  position?: string;
  /** 标签位置偏移 [offsetX, offsetY]，相对于蓝点(badge)的固定像素偏移 */
  labelPosition?: [number, number];
}

/**
 * 国家内工作室固定坐标点映射表
 * 每个国家最多支持5个工作室位置
 * [lng, lat] 格式
 */
export const COUNTRY_COORDINATES: Record<string, [number, number][]> = {
  UK: [
    [-3.4, 55.3], // center
    [-6, 54], // left
    [0, 53], // right
  ],
  Sweden: [
    [14, 59], // center
    [16, 61.5], // left
    [17, 64], // top
    [18, 66], // bottom
    [14.5, 57], // top-left
  ],
  Norway: [[8.5, 62]],
  'New Zealand': [[174.88, -41.28]],
  China: [
    [118, 40.5],
    [113, 24.5],
  ],
  Russia: [[105.3, 61.52]],
  Japan: [[138.25, 36.2]],
  Poland: [[19.14, 51.77]],
  US: [[-105, 40.09]],
  Germany: [[10.45, 51.17]],
  Korea: [[127.77, 35.91]],
  Canada: [
    [-105, 56.13], // center
    [-85, 52], // right
  ],
  Cyprus: [[33.43, 34.92]],
};

export const NEW_COUNTRY_COORDINATES: Record<string, [number, number][]> = {
  China: [[105, 35.91]],
};

export const COUNTRY_FULL_NAME: {
  [key: string]: string;
} = {
  UK: 'United Kingdom',
  US: 'United States',
  Korea: 'South Korea',
};

export const STUDIO_JSON: IStudio[] = [
  {
    name: 'Miniclip',
    est: 2001,
    country: 'UK',
    employee_count: 1532,
    employee_info:
      '1,532 total (R&D 1,105 / Publishing & Marketing 128 / Other 299',
    games: ['8 Ball Pool', 'Subway Surfers', 'Triple Match 3D'],
    game_engine: ['Unity', 'Cocos'],
    ratings: 4,
    studio_info:
      'A long-standing player in the casual game segment; quality and efficiency still have room to improve. Operates a multi-studio group model similar to Tencent—studios vary significantly, each with distinct strengths.',
    labelPosition: [-255, -215],
  },

  {
    name: 'DE',
    est: 1993,
    country: 'Canada',
    employee_count: 491,
    employee_info: '491 total (Engineering 106 / Art 130 / Product 94)',
    games: ['Warframe', 'Soulframe'],
    game_engine: ['Proprietary engine'],
    ratings: 3.5,
    studio_info:
      'Quality and delivery efficiency are relatively well balanced, but there is still a gap to industry-leading maturity and performance.',

    labelPosition: [-195, -170],
  },
  {
    name: 'GGG',
    est: 2006,
    country: 'New Zealand',
    employee_count: 215,
    employee_info: '215 total, including 155 in R&D',
    games: ['POE', 'POE2'],
    game_engine: ['Proprietary engine'],
    ratings: 2.5,
    studio_info:
      'Quality and delivery efficiency are relatively well balanced, but the development management toolchain is fairly lightweight, leaving clear headroom to further improve engineering productivity.',
    labelPosition: [-210, 20],
  },
  {
    name: 'Techland',
    est: 1991,
    country: 'Poland',
    employee_count: 397,
    employee_info: '397 total (Engineering 112 / Art 116 / Product 66)',
    games: ['DL', 'DL2', 'DLTB', 'DLO', 'DLTB2'],
    game_engine: ['Proprietary engine', 'UE5'],
    ratings: 3,
    studio_info:
      'Strong technical foundation built on the self-developed CEngine. Significant headroom to improve dev. efficiency. For new UE5-based projects, the team currently lacks accumulated UE5-specific expertise and tooling.',
    labelPosition: [19, 168],
  },
  {
    name: '10C',
    est: 2015,
    country: 'Sweden',
    employee_count: 101,
    employee_info: '101 total (Engineering 60 / Art 11 / Product 10)',
    games: ['GTFO', 'Den of Wolves'],
    game_engine: ['Unity 6'],
    ratings: 2,
    studio_info:
      'Quality and delivery efficiency are relatively well balanced, but there is still a gap to industry-leading maturity and performance.',
    labelPosition: [30, -199],
  },
  {
    name: 'Stunlock',
    est: 2009,
    country: 'Sweden',
    employee_count: 197,
    employee_info: '197 total(Engineering 11 / Art 17 / Product 8)',
    games: ['V Rising', 'V Rising 2'],
    game_engine: ['Unity'],
    ratings: 3.5,
    studio_info:
      'Transitioning new projects to UE5 and needs to build up engine expertise. Engineering productivity has room to improve; the current content pipeline is relatively outdated, resulting in slow new level creation.',
    labelPosition: [30, -105],
  },
  {
    name: 'Turtle Rock',
    est: 2002,
    country: 'US',
    employee_count: 209,
    employee_info: '209 total, including 189 in R&D',
    games: ['B4B2'],
    game_engine: ['UE5'],
    ratings: 3,
    studio_info:
      'Strong in PvE combat and AI design, with quality and delivery efficiency relatively well balanced. Client performance and backend services require close attention.',
    labelPosition: [-220, 60],
  },
  {
    name: 'Sharkmob',
    est: 2017,
    country: 'Sweden',
    employee_count: 160,
    employee_info: '160 total, including 135 in R&D',
    games: ['Exoborne'],
    game_engine: ['UE5'],
    ratings: 2,
    studio_info:
      'On UE5, the team is strong in animation and content creation, but has gaps in performance and rendering optimization, resulting in relatively low production efficiency.',

    labelPosition: [30, -10],
  },
  {
    name: 'Funcom',
    est: 1993,
    country: 'Norway',
    employee_count: 340,
    employee_info: '340 total, including 280 in R&D',
    games: ['Conan Exiles', 'Dune: Awakening'],
    game_engine: ['UE5'],
    ratings: 3,
    studio_info:
      'Has solid UE5 experience and balanced capabilities overall, but capacity planning and production management efficiency still have room to improve.',
    labelPosition: [-230, 50],
  },
  {
    name: 'Yager',
    est: 1999,
    country: 'Germany',
    employee_count: 76,
    employee_info: '76 total, including 61 in R&D',
    games: ['Sparrow'],
    game_engine: ['UE5'],
    ratings: 3,
    studio_info:
      'As Sparrowis an online multiplayer shooter, rendering and performance on the engine side are key risk areas. Engineering productivity also has room to improve.',
    labelPosition: [-200, 100],
  },
  {
    name: 'Mundfish',
    est: 2017,
    country: 'Cyprus',
    employee_count: 203,
    employee_info: '203 total; 100+ assigned to Cube',
    games: ['The Cube'],
    game_engine: ['UE5'],
    ratings: 3.5,
    studio_info:
      'Technical readiness for a large-scale online open-world UE5 project is currently insufficient. Prior experience is primarily UE4-based single-player shooter development. The team has some existing foundation in engineering productivity practices.',
    labelPosition: [15, 0],
  },
  {
    name: 'Lighthouse',
    est: 2022,
    country: 'UK',
    employee_count: 112,
    employee_info: '112 total (Engineering 28 / Art 48 / Product 21)',
    games: ['Wonderland'],
    game_engine: ['UE5'],
    ratings: 3,
    studio_info:
      'Built up meaningful UE5 experience; however, rendering and performance remain key bottlenecks. Productivity practices are partially established, with room to improve.',
    labelPosition: [-255, -135],
  },
  {
    name: 'Sumo',
    est: 2003,
    country: 'UK',
    employee_count: 911,
    employee_info: '911 total, including 757 in R&D',
    games: ['D7'],
    game_engine: ['UE5', 'Unity'],
    ratings: 2,
    studio_info:
      'Operates a loosely governed studio-group model. Engineering and production capabilities vary significantly across studios—some teams are very strong, while others materially lag behind.',
    labelPosition: [-255, -60],
  },
  {
    name: 'Fatshark',
    est: 2007,
    country: 'Sweden',
    employee_count: 197,
    employee_info: '197 total, including 172 in R&D',
    games: ['Darktide', 'Hydra'],
    game_engine: ['Proprietary engine', 'UE5'],
    ratings: 3,
    studio_info:
      'Transitioning new projects to UE5 and needs to build up engine expertise. Engineering productivity has room to improve; the current content pipeline is relatively outdated, resulting in slow new level creation.',
    labelPosition: [245, -148],
  },
  {
    name: 'Platinum',
    est: 2006,
    country: 'Japan',
    employee_count: 358,
    employee_info: '358 total, including 294 in R&D',
    games: ['Project 070', 'Project 071'],
    game_engine: ['Proprietary engine', 'UE5'],
    ratings: 3.5,
    studio_info:
      'Transitioning from a proprietary engine to Unreal and needs to build up Unreal expertise to safeguard quality. Project management is mature, and engineering productivity is relatively high.',
    position: 'right',
    labelPosition: [20, -76],
  },
  {
    name: 'Arrowhead',
    est: 2008,
    country: 'Sweden',
    employee_count: 102,
    employee_info: '102 total',
    games: ['Helldivers', 'Helldivers 2'],
    game_engine: ['Proprietary engine'],
    ratings: 4,
    labelPosition: [245, -55],
  },
  {
    name: 'Joy Workshop',
    est: 2017,
    country: 'China',
    employee_count: 260,
    employee_info: '260 total',
    games: ['GST'],
    game_engine: ['UE5'],
    ratings: 2,
    position: 'right',
    labelPosition: [20, 46],
  },
  {
    name: 'Inflexion',
    est: 2018,
    country: 'Canada',
    employee_count: 52,
    employee_info: '52 total, including 48 in R&D',
    games: ['Nightingale'],
    game_engine: ['UE5'],
    ratings: 2,
    studio_info:
      'Strong in PvE combat and AI design, with quality and delivery efficiency relatively well balanced. Client performance and backend services require close attention.',
    labelPosition: [-195, -82],
  },
  {
    name: 'Yongxing',
    est: 2021,
    country: 'China',
    employee_count: 165,
    employee_info: '165 (Engineering 31 / Art 78)',
    games: ['Nikke', 'Stellar Blade', 'Project Spirits'],
    game_engine: ['UE5'],
    sub_studio: {
      name: 'Shiftup',
      est: 2013,
      country: 'Korea',
      employee_count: 325,
      employee_info: 'Shift Up 325',
    },
    ratings: 3,
    studio_info:
      'Limited experience with unified three-platform development. Both delivery quality and engineering productivity face multiple unknown risks and challenges.',
    labelPosition: [20, 130],
  },
];
